(function () {
  if (typeof window === 'undefined') return;
  var html = document.documentElement;

  // Respect reduced-motion preference — render everything as-is, no animation.
  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduce || !('IntersectionObserver' in window)) {
    return;
  }

  // Signal to CSS that the reveal system is active.
  html.classList.add('sevl-reveal');

  var SELECTOR = [
    '.sevl-section [class*="__wrap"] > *',
    '.sevl-section [class*="__grid"] > *',
    '.sevl-section [class*="__cases"] > *'
  ].join(', ');
  var observed = new WeakSet();

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (!observed.has(nodes[i])) {
        observed.add(nodes[i]);
        io.observe(nodes[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Re-scan when Shopify's theme editor re-renders a section.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
